import { render, staticRenderFns } from "./InventoryModal.vue?vue&type=template&id=aba741a8&scoped=true"
import script from "./InventoryModal.vue?vue&type=script&lang=js"
export * from "./InventoryModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryModal.vue?vue&type=style&index=0&id=aba741a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba741a8",
  null
  
)

export default component.exports